import { createContext, useContext } from "react";

export const ThemeContext = createContext({ isDark: false, toggleDark: () => {} });

export function useIsDark() {
    return useContext(ThemeContext).isDark;
}

export function useToggleDark() {
    return useContext(ThemeContext).toggleDark;
}
